import React from "react";
import Svg from "../Svg/Svg";
import "./button.scss";

const Button = ({ children, onClick, active }) => (
  <div className={`button-filter ${active ? "active" : ""}`} onClick={onClick}>
    <Svg name={children.toString().trim()} /> {children.replace("and", "&")}
  </div>
);

export default Button;
